const track = (event, properties, options, callback) => {
  console.log("track, event", event, "props", properties);
  window.analytics.track(event, properties, options, callback);
};

export const events = {
  CLICKED_ELEMENT: "Clicked Element"
};

export default {
  events: events,
  track: track
};



// WEBPACK FOOTER //
// ./src/utils/analytics.js